import { BaasicButton } from 'core/components';
import { observer } from 'mobx-react';
import React from 'react';

const DeletePalletDropdownAction = ({ onClick, data }) => {
	return (
		<BaasicButton className="btn btn--sml btn--ghost btn--icon" icon="fa fa-trash" onClick={() => onClick(data)} />
	);
};

export default observer(DeletePalletDropdownAction);



// WEBPACK FOOTER //
// ./src/core/components/select/actions/DeletePalletDropdownAction.jsx